export enum PUSH_PLATFORM {
  "IOS" = "ios",
  "ANDROID" = "android",
}
